import React, {FC} from "react"
import {Body, H2} from "@irati/ui/src/Typography"
import {ButtonRouterLink} from "@irati/ui/src/Link"
import FormattedMessage, {useIntl} from "@irati/utils/lang"
import theme from "@irati/ui/src/global/theme"
import Flex from "@irati/ui/src/Flex"
import {BenefitFaqContainer} from "../../styled"

interface Props {
  title?: string
  subtitle?: string
  faqCtaText?: string
  faqCtaUrl?: string
}

export const BenefitFAQ: FC<Props> = ({title, faqCtaText, subtitle, faqCtaUrl}) => {
  const {formatMessage} = useIntl()

  return (
    <Flex justifyContent="center">
      <BenefitFaqContainer>
        <Flex direction="column" gap={2} alignItems="flex-start" justifyContent="space-between">
          <H2 color={theme.colors.primary2}>
            <FormattedMessage id={title} />
          </H2>
          {subtitle && (
            <Body color={theme.colors.greys.black} maxWidth="100%">
              <FormattedMessage id={subtitle} />
            </Body>
          )}
          {faqCtaText && (
            <ButtonRouterLink to={formatMessage({id: faqCtaUrl})} mobileFull>
              <FormattedMessage id={faqCtaText} />
            </ButtonRouterLink>
          )}
        </Flex>
      </BenefitFaqContainer>
    </Flex>
  )
}
